import React, { Component, Fragment } from 'react';
import EventSlot from './event_slot';
import ViewingEventIcon from '../../images/viewing-event-icon.svg';
import HttpRequestor from '../utils/http_requestor';
import LoginOrSignupForm from './login_or_signup_form';
import ResendConfirmation from './resend_confirmation';
import ConfirmTimeslot from './confirm_timeslot';
import I18n from '~/utils/translations';
import _isEmpty from 'lodash/isEmpty';

export default class ViewingEventSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedSlot: this.props.selectedSlot,
      submitting: false,
      submitted: false,
      user: {},
    };
  }

  bookViewingEventSlot = (params) => {
    let requestParams = {
      property_id: this.props.property.id,
      viewing_event_id: this.state.selectedSlot.id,
      start_time: this.state.selectedSlot.startTime,
      listing_id: this.props.listing,
    };

    if (params['email']) {
      requestParams.email = params['email'];
    }

    this._submit(requestParams);
  };

  _submit = (params) => {
    this.setState({ submitting: true });
    const requestor = new HttpRequestor();
    requestor
      .call(`/homes/${this.props.property.id}/viewings`, 'POST', {
        data: {
          type: 'viewing',
          attributes: params,
        },
      })
      .then(this._submitSuccess)
      .catch(this._submitError);
  };

  _submitSuccess = (response) => {
    this.setState({ submitted: true });
    track_viewing(response.id);
    track_event('home-viewing-flow', 'viewing-event-submission', 'success');
    this.props.handleViewingBooked(this.state.selectedSlot, response.id);
  };

  _submitError = (response) => {
    this.setState({ submitting: false, submitError: 'Something went wrong, please try again' });
    track_event('home-viewing-flow', 'viewing-event-submission', 'error');
  };

  selectSlot = (e, slot) => {
    this.setState({
      selectedSlot: slot,
    });
  };

  onUserChanged = (user) => {
    this.setState({ user });
  };

  renderSlots() {
    return this.props.viewingEvents.map((eventSlot) => {
      const slotSelected = this.state.selectedSlot && this.state.selectedSlot.id == eventSlot.id;

      return (
        <EventSlot
          key={eventSlot.id}
          slot={eventSlot}
          onClick={(e) => this.selectSlot(e, eventSlot)}
          selected={slotSelected}
        />
      );
    });
  }

  renderLastSection() {
    if (this.props.submitted || (this.props.userHasSession && !this.userIsGuest())) {
      return (
        <ConfirmTimeslot
          propertyAddress={this.userIsGuest() ? this.props.property.fullAddress : this.props.property.privatisedAddress}
          property={this.props.property}
          datetime={this.state.selectedSlot.timeLabel}
          loading={this.state.submitting}
          submitted={this.state.submitted}
          submitError={this.state.submitError}
          onConfirm={this.bookViewingEventSlot}
          viewingEvent={true}
        />
      );
    }
  }

  userIsGuest() {
    const user = this.state;
    return user.user_exists && !user.user_registered;
  }

  renderLastSectionButtons() {
    if (this.state.user.user_exists && !this.state.user.user_registered) {
      // Resend confirmation
      if (this.state.user.upcoming_viewing_for_property) {
        return <ResendConfirmation propertyId={this.props.property.id} userEmail={this.state.user.email} />;
      }
    }
  }

  onInformationChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  prequalRequired() {
    const { property, latestCustomPreQualificationAnswers, preQualificationQuestions, isFullUser } = this.props;

    if (!property.preQualificationEnabled) {
      return false;
    }

    const latestCustomAnswersEmpty = _isEmpty(latestCustomPreQualificationAnswers);

    if (latestCustomAnswersEmpty) {
      return true;
    }

    const customPreQualAnswersIncomplete = preQualificationQuestions.some((requiredQuestion) => {
      if (requiredQuestion.required) {
        const answer = latestCustomPreQualificationAnswers.find(
          (answer) => answer && answer.question.key === requiredQuestion.key
        );
        return !answer;
      }
      return false;
    });

    return !isFullUser && customPreQualAnswersIncomplete;
  }

  render() {
    const prequalRequired = this.prequalRequired();
    const showLoginForm = prequalRequired || !(this.props.submitted || this.props.userHasSession);
    const showPreQualDecline = this.props.property.preQualificationEnabled && !this.props.preQualPassed;

    return (
      <section
        id="book-viewing-event"
        className="book-viewing-event"
        data-event-count={this.props.viewingEvents.length}
      >
        {showLoginForm && (
          <Fragment>
            <LoginOrSignupForm
              registerUrl="/users/viewing-register"
              property={this.props.property}
              listing={this.props.listing}
              doorbellHost={this.props.doorbellHost}
              buttonText={I18n.t('login_or_signup.new_user.button')}
              onUserChanged={this.onUserChanged}
              onSignIn={this.onSignIn}
              signInRedirect={window.location.href}
              trackCategory="home-viewing-flow"
              trackAction="viewing-submission"
              trackLabel="success"
              facebookEvent="CompleteRegistration"
              renderLastSectionButtons={this.renderLastSectionButtons()}
              defaultEmail={this.props.email}
              preQualificationQuestions={this.props.preQualificationQuestions}
              customPreQualificationAnswers={this.props.latestCustomPreQualificationAnswers}
              signedIn={this.props.userHasSession && !this.userIsGuest()}
            />
          </Fragment>
        )}
        {!showLoginForm && (
          <Fragment>
            {showPreQualDecline && (
              <Fragment>
                <p>{I18n.t('viewings.pre_qual_result.headline')}</p>
                <br />
                <p>
                  {I18n.t('viewings.pre_qual_result.fail.line1', {
                    property: this.props.property.headline,
                  })}
                </p>
                <p>{I18n.t('viewings.pre_qual_result.fail.line2')}</p>
              </Fragment>
            )}

            {!showPreQualDecline && (
              <Fragment>
                <p>{I18n.t('viewings.pre_qual_result.headline')} </p>
                <br />
                <p>{I18n.t('viewings.pre_qual_result.pass')}</p>
                <div className="book-viewing-event__options book-viewing-section ">
                  <div className="book-viewing-section__inner">
                    <div className="book-viewing-event__header ">
                      <img className="book-viewing-event__icon" src={ViewingEventIcon} />
                      <h1 className="book-viewing-event__title">{I18n.t('viewings.events.title')}</h1>
                    </div>

                    <div className="book-viewing-event__content">
                      <p className="book-viewing-event__intro">{I18n.t('viewings.events.intro')}</p>

                      <div className="book-viewing-event__slots">{this.renderSlots()}</div>
                      <a
                        className="book-viewing-event__book-viewing"
                        href="#viewings"
                        data-trigger="book-individual-viewing"
                        data-ga-category="home-viewing-flow"
                        data-ga-action="switch-to-viewings"
                        onClick={this.props.showOtherOptions}
                      >
                        {I18n.t('viewings.events.link_to_individual_bookings')} &rsaquo;
                      </a>
                    </div>
                  </div>
                </div>

                {this.state.selectedSlot && this.state.selectedSlot.timeLabel && this.renderLastSection()}
              </Fragment>
            )}
          </Fragment>
        )}
      </section>
    );
  }

  onSignIn = () => {
    const { selectedSlot } = this.state;

    const selected = {
      slot: (selectedSlot && selectedSlot.id) || null,
    };

    sessionStorage.setItem('selectedTime', JSON.stringify(selected));
  };
}
